// ─── PORTES — fonte única de verdade ────────────────────────────────────────
//
// São DOIS valores distintos e nunca podem ser confundidos:
//
//   COBRADOS  1.00 €/un  → acrescentados ao preço de cada artigo, a TODOS os
//                          clientes (sem tiers). Não sofrem desconto.
//   CUSTO     0.75 €/un  → o que a LOGNOW paga ao transportador.
//
// A diferença (+0.25 €/un) é margem nossa. Usar o mesmo valor dos dois lados
// apaga essa margem — foi o bug corrigido em 26/07/2026.
//
// Regra: quem calcula RECEITA usa COBRADOS; quem calcula CUSTO usa CUSTO.
// O desconto do cliente incide sobre (preço − COBRADOS), nunca sobre os portes.

export const PORTES_COBRADOS_FALLBACK = 1.00   // config_sistema.portes_por_unidade
export const PORTES_CUSTO_FALLBACK = 0.75      // config_sistema.portes_custo_por_unidade

const num = (v, fallback) => {
  const n = parseFloat(String(v ?? '').replace(',', '.'))
  return (!isNaN(n) && n >= 0) ? n : fallback
}

// Lê os dois valores de config_sistema. Nunca rejeita: se a leitura falhar,
// devolve os fallbacks para a página continuar a funcionar com os valores certos.
export async function carregarPortes(supabase) {
  try {
    const { data } = await supabase
      .from('config_sistema').select('chave, valor')
      .in('chave', ['portes_por_unidade', 'portes_custo_por_unidade'])
    const cfg = {}
    for (const r of (data || [])) cfg[r.chave] = r.valor
    return {
      cobrados: num(cfg['portes_por_unidade'], PORTES_COBRADOS_FALLBACK),
      custo: num(cfg['portes_custo_por_unidade'], PORTES_CUSTO_FALLBACK),
    }
  } catch {
    return { cobrados: PORTES_COBRADOS_FALLBACK, custo: PORTES_CUSTO_FALLBACK }
  }
}
